export default {
    deletingBreakTags: false,
    toDelete: null,
    deletionInProgress: false,

    deleteConfirmation: null,
    deleteConfirmationInfo: null,
}


// WEBPACK FOOTER //
// ./public/pages/EditBreak/DeleteBreakTagModal/initialState.js